import React, {useEffect} from "react";
import {RegisterValue} from "../../fstn/register";
import {ProjectDetails} from "../../redux/types/firebase";
import {ParameterDescription} from "../../fstn/action";
import SelectMarshalStorage from "./SelectMarshalStorage";

interface Props {
    name: string
    onChangeValue: (key: string, value: RegisterValue | undefined) => void
    parameter: ParameterDescription
    projectDetails: ProjectDetails
    source: string
    value: RegisterValue
}

export default function SelectMarshalAudio({name, onChangeValue, parameter, projectDetails, source, value}: Props) {
    useEffect(() => {}, []);
    return (
        <SelectMarshalStorage
            name={name} onChangeValue={onChangeValue} parameter={parameter} source={source} value={value as string}
            upload="audio/*">
            <audio controls src={`${projectDetails.audioSource}/${value as string}`}/>
        </SelectMarshalStorage>
    );
}